goog.provide('el8.app.shared.dialog.apptHistory');

goog.require('el8.uiwidget.NewDialog');
goog.require('el8.template.apphome.scheduler.dialog');
goog.require('el8.model.base');
goog.require('el8.practicedata.model.appt');
goog.require('el8.uiwidget.collapsible');
goog.require('el8.appservice.search');
goog.require('el8.util.amplitude.schedulerHelpers');

el8.app.shared.dialog.apptHistory = (function() {

    var that = new el8.uiwidget.NewDialog({
        title: 'Patient\'s Appointments',
        autoHeight: true,
        width: 600,
        contentFn: el8.template.apphome.scheduler.dialog.apptHistory,
        showXButton: true
    });

    that._onApptCreatedCallback = null;
    that._currPatientId = null;
    that._patientPastApptSet = new el8_EntitySet({ model: el8.practicedata.model.appt });
    that._patientFutureApptSet = new el8_EntitySet({ model: el8.practicedata.model.appt });
    that._fromChart = null;

    var super_init = that._init;
    that._init = function() {
        super_init.call(that);
        that._bindTriggers();
    };

    var super_show = that.show;
    that.show = function(_patientId) {
        super_show.call(that);
        that._search(_patientId || null);
        el8.practicedata.appts.bind('all', apptUpdateListener);
    };

    // called from chart, get ptid from globals
    that.showCurrentPt = function() {
        if (!el8Globals.PATIENT_ID) { return; }
        that._currPatientId = el8Globals.PATIENT_ID;
        that._fromChart = true;
        that.show(that._currPatientId);

        // remove unneeded DOM elements
        $('.appt-search-box-container', that.getContentElt()).remove();
        $('.appt-list-button-container', that.getContentElt()).remove();
        $('.patient-trigger', that.getContentElt()).remove();
        $('.appt-patient-info-details', that.getContentElt()).remove();
    };

    // called from react side, when we want to have a trigger to know when new
    // appts have been created
    that.setOnApptCreatedCallback = function(callback) {
        that._onApptCreatedCallback = callback;
    };

    var super_hide = that.hide;
    that.hide = function() {
        super_hide.call(that);
        el8.practicedata.appts.unbind('all', apptUpdateListener);
    };

    that._search = function(_patientId) {
        that._currPatientId = _patientId || that._currPatientId;
        $('.appt-list', that.getContentElt()).empty().addClass('dataLoading');
        if (that._currPatientId) {
            if (!that._fromChart) { that._populatePatient(); }

            $.el8_ajax({
                type: 'GET',
                url: el8.service.urls.get('getPatientAppointments', [that._currPatientId]),
                success: function(data) {
                    that._patientPastApptSet.reset().create(data['past_appts']);
                    that._patientFutureApptSet.reset().create(data['future_appts']);
                    that._renderList('past');
                    that._renderList('future');
                    that.adjustHeight();
                }
            });
        }
    };

    that._refresh = function() {
        if (that._currPatientId) { that._search(that._currPatientId); }
    };

    that._renderList = function(type) {
        if (type === 'past') {
            $('.appt-list', that._$pastAppts)
                .removeClass('dataLoading')
                .html(el8.template.apphome.scheduler.dialog.apptSearchList({
                    appts: that._patientPastApptSet.all().map(function(a) {
                        var map = a.asSoyMap();
                        map['physicianFullName'] = a.getPhysicianUserFullName();
                        return map;
                    }),
                    type: 'past'
                }));
        } else if (type === 'future') {
            $('.appt-list', that._$futureAppts)
                .removeClass('dataLoading')
                .html(el8.template.apphome.scheduler.dialog.apptSearchList({
                    appts: that._patientFutureApptSet.all().map(function(a) {
                        var map = a.asSoyMap();
                        map['physicianFullName'] = a.getPhysicianUserFullName();
                        return map;
                    }),
                    type: 'upcoming',
                    editable: that._fromChart ? false: true
                }));
        }
    };

    that._populatePatient = function() {
        if (that._currPatientId) {
            var _currPatientItem = el8.ptdata.patients.getById(that._currPatientId);

            $('.patient-trigger', that.getContentElt())
                .text(_currPatientItem.getReverseName())
                .attr('data-url', '/patient/'+that._currPatientId+'/');

            var dob = _currPatientItem.getDob() ? 'D.O.B.: ' + _currPatientItem.getDob().asString() : '';
            var age = _currPatientItem.getDisplayAge() ? '(Age: ' + _currPatientItem.getDisplayAge() + ')' : '';

            $('.patient-dob', that.getContentElt()).text(dob);
            $('.patient-age', that.getContentElt()).text(age);
        }
    };

    that._onApptClick = function (appt) {
        el8React.dispatch.closeSnapshotDialog();
        el8React.dispatch.setCurrentDate(new Date(appt.getApptTime()));
        el8React.dispatch.setCurrentPhysicianUserId(appt.getPhysicianUserId());
        el8React.dispatch.setAutoSelectedEventId(appt.getId());
    };

    that._bindTriggers = function() {
        that._$pastAppts = $('#appt-search-past-appts', that.getContentElt());
        that._$pastAppts.on('click', '.appt-search-entry',  function(e) {
            if (that._fromChart) { return; }
            var itemId = $(this).attr('data-id');
            var apptToEdit = that._patientPastApptSet.getById(itemId);
           that._onApptClick(apptToEdit);
        });
        that._$futureAppts = $('#appt-search-future-appts', that.getContentElt());
        that._$futureAppts.on('click', '.appt-search-entry',  function(e) {
            if (that._fromChart) { return; }
            var itemId = $(this).attr('data-id');
            var apptToEdit = that._patientFutureApptSet.getById(itemId);
            that._onApptClick(apptToEdit);
        });
        that.getContentElt().on('click', '.patient-trigger',  function(e) {
            if (that._fromChart) { return; }
            var url = $(this).attr('data-url');
            if (url) { window.open(url); }

        }).on('click', 'button',  function(e) {
            if (that._fromChart) { return; }
            var action = $(this).attr('data-action');
            switch(action) {
                case 'create-appt':
                    var _currPatientItem = el8.ptdata.patients.getById(that._currPatientId);
                    if (!_currPatientItem) { return; }
                    el8.apphome.scheduler.dialog.apptDetails.show({
                        patientItem: _currPatientItem.asAutocompleteMap(),
                        onSaveCallback: that._onApptCreatedCallback
                    });
                    el8.util.amplitude.logOpenCreateNewApptDialog('Calendar Search Bar - + Create Appointment');
                    break;
                case 'refresh':
                    that._refresh();
                    break;
                default:
                    return;
            }
        });
        el8.uiwidget.collapsible({
            container: $('.appt-list', that._$pastAppts),
            triggerElt: $('.appt-list-header', that._$pastAppts),
            statusElt: $('.appt-list-status', that._$pastAppts)
        });
        el8.uiwidget.collapsible({
            container: $('.appt-list', that._$futureAppts),
            triggerElt: $('.appt-list-header', that._$futureAppts),
            statusElt: $('.appt-list-status', that._$futureAppts)
        });

        el8.appservice.search.patientField({
            inputField: $('#appt-search-patient', that.getContentElt()),
            text: "Find appointments by patient...",
            selectFn: function(event, mindreaderItem) {
                that._search(mindreaderItem.id);
            }
        });

    };

    function apptUpdateListener(eventName, item) {
        // we just care about the built-in events (create, update, delete)
        if (eventName === 'LOCAL_UPDATE' || eventName === 'LOCAL_DELETE') { return; }
        // sometimes we'll get updates about empty lists
        if (!item || !item.getPatientId) { return; }
        if (item.getPatientId() === that._currPatientId) {
            that._refresh();
        }
    }

    return that;

})();
